import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { map, Observable } from 'rxjs';
import { GetSiteConfigurationResponse } from '../../shared/models/get-site-configuration.response';
import { SiteConfiguration } from '../../shared/models/site-configuration.model';
import { LoadSiteConfigurationByKeyRequest } from './load-site-configuration-by-key.request';

@Injectable({ providedIn: 'root' })
export class LoadSiteConfigurationByKeyUseCase extends UseCase<LoadSiteConfigurationByKeyRequest, Observable<SiteConfiguration>> {
    private _apiRequestService = inject(ApiRequestService);
    private _configuratorBaseUrl = inject<string>('CONFIGURATOR_BASE_URL' as any);
    private _getSiteConfigurationUrl = '/websiteconfigurator/get-site-configuration';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(
        request: LoadSiteConfigurationByKeyRequest | void
    ): Observable<SiteConfiguration> | void {
        return this._apiRequestService
            .sendRequest<{}, GetSiteConfigurationResponse>(this._configuratorBaseUrl, {}, true, this._getSiteConfigurationUrl)
            .pipe(
                map((response) => {
                    const list = response.siteConfigurationList as SiteConfiguration[];
                    const entry = list.find((c) => c.configurationKey === (request as LoadSiteConfigurationByKeyRequest).configurationKey);
                    return entry ?? { configurationKey: (request as LoadSiteConfigurationByKeyRequest).configurationKey, configurationValue: '', active: false };
                })
            );
    }
}
